<template>
  <v-content style="margin-block: 50px; margin-top: -85px; border-radius: 20px; width: 100%; height: 100%;"> Updated background color
    <v-container grid-list-xl style="margin-top: 20px;">
      <!-- Logo -->
      <v-row>
        <v-col class="text-center">
          <v-img
            src="@/assets/images/Burgerland Logo Icon_500px.png"
            height="200"
            contain
            class="my-3"
            style="top: 20px;"
          ></v-img>
        </v-col>
      </v-row>
      <v-row id="welcome">
  <v-col class="text-center">
    <v-btn color="primary" @click="welcomeAndStartRecording">
      Welcome, start order <v-icon :color="recordingStateColor">mdi-microphone</v-icon>
    </v-btn>
    
    <span v-if="isRecording">
      <div class="dots-container">
        <div class="dots"></div>
        <div class="dots"></div>
        <div class="dots"></div>
      </div>
    </span>
  </v-col>
</v-row>

       <!-- Dynamic Info Display -->
       <v-dialog v-model="overlayVisible" persistent max-width="600px">
  <v-card dark class="info-dialog">
    <v-card-title class="headline"></v-card-title>
    <v-card-text class="custom-text">{{ overlayMessage }}</v-card-text>
  </v-card>
</v-dialog>
<v-divider></v-divider>
<v-row key="sm-video" style="margin-top: 20px;">
        <v-col cols="6" sm="6" md="6" lg="6">
          <video id="sm-video" ref="toggleVideo" style="width: 100%; height: 100%;"></video>
        </v-col>
        <v-col cols="6" sm="6" md="6" lg="6">
          <v-card id="cart">
  <v-card-title class="headline">Your Cart</v-card-title>
  <v-card-text>
    <v-list>
      <v-list-item v-for="item in cart" :key="item.id">
        <v-list-item-avatar>
          <v-img :src="item.image" height="100px"></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ item.name }}</v-list-item-title>
          <v-list-item-subtitle>${{ item.price.toFixed(2) }}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-icon @click="removeFromCart(item)">mdi-delete</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-list>
    <v-divider></v-divider>
    <div class="cart-summary">
      <p>Total Items: {{ cart.length }}</p>
      <p>Subtotal: ${{ subtotal.toFixed(2) }}</p>
      <p>Taxes (8%): ${{ taxAmount.toFixed(2) }}</p>
      <p>Grand Total: ${{ grandTotal.toFixed(2) }}</p>
    </div>
  </v-card-text>
</v-card>
        </v-col>
        </v-row>
      
  <!-- <v-col v-for="combo in totalPrices" :key="combo.id" cols="6" sm="6" md="6" lg="6">
    <v-card>
      <v-img :src="combo.image" height="300px" class="black--text align-end" gradient="to top, rgba(0,0,0,.1), rgba(0,0,0,.5)" :alt="combo.name">
        <v-card-title>{{ combo.name }}</v-card-title>
      </v-img>
      <v-card-text class="text-center">
        <div class="menutext">{{ combo.description }}</div>
        <v-divider></v-divider>
        <div class="menutext">{{ combo.calories }} Cal.</div>
        <v-divider></v-divider>
        <div class="menutext">${{ combo.price }}</div>
        <v-divider></v-divider>
        <v-select v-model="selectedOptions[combo.id].drinks"
                  :items="combo.options.drinks"
                  label="Select drink size"
                  outlined dense>
        </v-select>
        <v-select v-model="selectedOptions[combo.id].fries"
                  :items="combo.options.fries"
                  label="Select fries size"
                  outlined dense>
        </v-select>
        <v-select v-model="selectedOptions[combo.id].pieces"
                  :items="combo.options.pieces"
                  label="Select McNugget pieces"
                  outlined dense>
        </v-select>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn color="primary" @click="addToCart(combo)">Add to Cart</v-btn>
      </v-card-actions>
    </v-card>
  </v-col> -->
  <v-row>
  <v-col
      v-for="combo in totalPrices"
      :key="combo.id"
      cols="4"
      sm="4"
      md="4"
      lg="2"> <!-- Adjust the column sizes to show more items per row -->
      <v-card class="mx-auto" max-width="256px"> <!-- Reduce the maximum width to make the cards smaller -->
        <v-img
          :src="combo.image"
          height="150px"
          class="black--text align-end"
          gradient="to top, rgba(0,0,0,.1), rgba(0,0,0,.5)"
          :alt="combo.name">
          
        </v-img>\
        <v-card-title class="center-text">{{ combo.name }}</v-card-title>

        <v-card-text>
          <!-- <div class="menutext">{{ combo.description }}</div>
          <v-divider></v-divider>
          <div class="menutext">{{ combo.calories }} Cal.</div>
          <v-divider></v-divider> -->
          <div class="menutext">${{ combo.price }}</div>
          <!-- <v-divider></v-divider>
          <v-select
            v-model="selectedOptions[combo.id].drinks"
            :items="combo.options.drinks"
            label="Select drink size"
            solo
            dense
            small>
          </v-select>
          <v-select
            v-model="selectedOptions[combo.id].fries"
            :items="combo.options.fries"
            label="Select fries size"
            solo
            dense
            small>
          </v-select>
          <v-select
            v-model="selectedOptions[combo.id].pieces"
            :items="combo.options.pieces"
            label="Select McNugget pieces"
            solo
            dense
            small>
          </v-select> -->
        </v-card-text>
        <!-- <v-card-actions class="justify-center">
          <v-btn color="primary" @click="addToCart(combo)" small> 
            Add to Cart
          </v-btn>
        </v-card-actions> -->
      </v-card>
    </v-col>


</v-row>
      <v-dialog v-model="cartDialog" persistent max-width="600px">
  <v-card>
    <v-card-title class="headline">Your Cart</v-card-title>
    <v-card-text>
      <v-list>
        <v-list-item v-for="item in cart" :key="item.id">
          <!-- Image for the combo -->
          <v-list-item-avatar>
            <v-img :src="item.image" height="100px"></v-img>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ item.name }}</v-list-item-title>
            <v-list-item-subtitle>${{ item.price }}</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-icon @click="removeFromCart(item)">mdi-delete</v-icon>
          </v-list-item-action> 
        </v-list-item>
      </v-list>
    </v-card-text>
    <v-card-actions>
      <v-btn color="blue darken-1" text @click="cartDialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>


<checkout
  :visible="checkoutDialog"
  :cart="cart"
  :subtotal="subtotal"
  :taxAmount="taxAmount"
  :grandTotal="grandTotal"
  @close="checkoutDialog = false"
  @order-submitted="handleOrderSubmitted"
/>
      <!-- Checkout Dialog -->
      <v-dialog v-model="checkoutDialog" persistent max-width="600px">
        <v-card>
          <v-card-title class="headline">Checkout</v-card-title>
          <v-form ref="form" v-model="valid">
            <v-text-field v-model="customer.name" :rules="[rules.required]" label="Full Name"></v-text-field>
            <v-text-field v-model="customer.email" :rules="[rules.email]" label="Email"></v-text-field>
            <v-text-field type="number" v-model="customer.phone" :rules="[rules.required]" label="Phone Number"></v-text-field>
          </v-form>
          <v-card-actions>
            <v-btn color="green darken-1" text @click="submitOrder">Place Order</v-btn>
            <v-btn color="red darken-1" text @click="checkoutDialog = false">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-content>
</template>

<script>
import axios from 'axios';
import submitAudio from '../assets/audio/input5.wav';
import successAudio from "../assets/audio/ordersuccess.wav";
import Checkout from './Checkout.vue';
export default {
  data() {
    return {
      cartDialog: false,
      checkoutDialog: false,
      overlayVisible: false,
      overlayMessage: '',
      firstTime: true,
      cart: [],
      taxRate: 0.08,
      customer: { name: '', email: '', phone: '' },
      valid: true,
      selectedOptions: {},
      basePrices: {
        drinks: { 'Small': 0, 'Medium': 1, 'Large': 2 },
        fries: { 'Small': 0, 'Medium': 1, 'Large': 2 },
        pieces: { '4 piece': 3.99, '6 piece': 4.99, '10 piece': 6.49, '20 piece': 11.99, '40 piece': 19.99 }
      },
      combos: [
        { id: 1, name: "Classic Burger Combo", description: "Includes a basic burger, medium fries, and a medium soft drink.", calories: 850, price: 9.99, image: "https://macheenist.com/wp-content/assets/classiccheese.png", options: { drinks: ['Small', 'Medium', 'Large'], fries: ['Small', 'Medium', 'Large'] } },
        { id: 2, name: "Cheeseburger Delight", description: "Features a cheeseburger, medium fries, and a medium soft drink.", calories: 900, price: 8.99, image: "https://macheenist.com/wp-content/assets/cheeseburger_delight.png", options: { drinks: ['Small', 'Medium', 'Large'], fries: ['Small', 'Medium', 'Large'] } },
        { id: 3, name: "Chicken Sandwich Meal", description: "Grilled or crispy chicken sandwich, medium fries, and a medium drink.", calories: 770, price: 8.49, image: "https://macheenist.com/wp-content/assets/chicken_sandwich_meal.png", options: { drinks: ['Small', 'Medium', 'Large'], fries: ['Small', 'Medium', 'Large'] } },
        { id: 4, name: "Nugget Feast", description: "10 chicken nuggets, medium fries, and a medium soft drink.", calories: 580, price: 9.99, image: "https://macheenist.com/wp-content/assets/nugget_feast.png", options: { drinks: ['Small', 'Medium', 'Large'], fries: ['Small', 'Medium', 'Large'], nuggets: ['10 piece', '15 piece'] } },
        { id: 5, name: "Mix & Match Combo", description: "Choice of any two: burger, cheeseburger, or chicken sandwich, with medium fries and a medium drink.", calories: 1100, price: 10.99, image: "https://macheenist.com/wp-content/assets/cheeseburger_delight.png", options: { drinks: ['Small', 'Medium', 'Large'], fries: ['Small', 'Medium', 'Large'] } },
        { id: 6, name: "Kids Meal", description: "Small burger or 4 chicken nuggets, small fries, and a juice box.", calories: 450, price: 6.49, image: "https://macheenist.com/wp-content/assets/kidsmeal.png", options: { drinks: ['Juice box'], fries: ['Small'], nuggets: ['4 piece'] } }
      ],
      isRecording: false,
      recordingStateColor: 'green', // Default color
      speechRecognition: new (window.SpeechRecognition || window.webkitSpeechRecognition)(),

      rules: {
        required: value => !!value || 'Required.',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'Invalid email.';
        }
      }
    };
  },
  created() {
    this.initializeSelectedOptions();
  },
  mounted() {
    // Trigger the prompt and start recording after the component is mounted
    setTimeout(() => {
      this.welcomeAndStartRecording();
    }, 2000);
  },
  components: {
    Checkout
  },
  methods: {
    handleOrderSubmitted() {
      this.cart = [];
      this.customer = {};
      this.checkoutDialog = false;
    },
    scrollToElement(elementId) {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  },
    initializeSelectedOptions() {
      this.combos.forEach(combo => {
        this.$set(this.selectedOptions, combo.id, {
          drinks: combo.options.drinks[0], // Initialize with the first available drink size
          fries: combo.options.fries ? combo.options.fries[0] : undefined, // Check if fries options exist
          pieces: combo.options.pieces ? combo.options.pieces[0] : undefined // Check if pieces options exist
        });
      });
    },
    welcomeAndStartRecording() {
    let message;
    if (this.firstTime) {
      message = 'Welcome to Burgerland AI order assistant. Please say "order" followed by the name of the combo to add it to your cart.';
      this.firstTime = false;  // Update the flag after the first message
    } else {
      const welcomeMessages = [
        // 'Hello! What can I get for you today?',
        // 'Good day! Ready to order your favorite meal?',
        // 'Hi there! What would you like to eat today?',
        // 'Welcome back! What are you craving today?'
      ];
      
      // Randomly select a welcome message from the list for subsequent interactions
      const messageIndex = Math.floor(Math.random() * welcomeMessages.length);
      message = welcomeMessages[messageIndex];
    }
  
    this.readOutLoud(message);
    setTimeout(() => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
}, 2000);
  
setTimeout(() => {
  // Calculate the maximum scrollable height of the document
  const bottomOfPage = document.body.scrollHeight - window.innerHeight;

  // Scroll to the bottom of the page
  window.scrollTo({ top: bottomOfPage, behavior: 'smooth' });
}, 4000);
setTimeout(() => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
}, 10000);
setTimeout(() => {
      new Audio(submitAudio).play();
}, 20000);
    // Setup recording with a delay to allow the speech to finish
    setTimeout(() => {
      this.startRecording();
    }, 20000); // Delay should be long enough for the speech to be completed

    // Automatically stop recording after a set time
    setTimeout(() => {
      this.stopRecording();
    }, 30000); // Adjust timing based on testing
  },
  readOutLoud(msg) {
    const speech = new SpeechSynthesisUtterance(msg);
    const voices = window.speechSynthesis.getVoices();

    // Find the "Google UK English Female" voice or fallback to the first available female voice
    const preferredVoice = voices.find(voice => voice.name === "Google UK English Female");
    const fallbackVoice = voices.find(voice => voice.lang.includes('en-GB') && voice.gender === 'female');

    speech.voice = preferredVoice || fallbackVoice || voices[0];  // Use the preferred or fallback voice, or default to the first voice
    speech.pitch = 1;
    speech.rate = 1;
    speech.volume = 1;
      window.speechSynthesis.speak(speech);
      this.displayResponse(msg);
    },
    displayResponse(message) {
      this.overlayMessage = message;
      this.overlayVisible = true;
      setTimeout(() => {
        this.overlayVisible = false;
        this.askForFurtherAction();
      }, 5000);
    },


  startRecording() {
    this.isRecording = true;
    this.recordingStateColor = 'blue'; // Indicate recording is active
    this.speechRecognition.start();

    this.speechRecognition.onresult = event => {
      const speechToText = event.results[0][0].transcript.toLowerCase();
      console.log("Recognized:", speechToText);
      this.processVoiceCommand(speechToText);
    };
  },

  stopRecording() {
    this.isRecording = false;
    this.recordingStateColor = 'green'; // Reset recording indicator
    this.speechRecognition.stop();
  },
  
processVoiceCommand(command) {
  let handled = false;
  const normalizedCommand = command.toLowerCase(); // Normalize the command once for all checks

  this.combos.forEach(combo => {
    const comboNameOrId = normalizedCommand.includes(combo.name.toLowerCase()) || normalizedCommand.includes(`combo ${combo.id}`);
    
    if (normalizedCommand.startsWith('order') && comboNameOrId) {
      this.addToCart(combo);
      handled = true;
    }
    
    if ((normalizedCommand.includes('describe') || normalizedCommand.includes('what is')) && comboNameOrId) {
      // this.readOutLoud(combo.description);
      handled = true;
    }

    if (normalizedCommand.includes('price') && comboNameOrId) {
      // this.readOutLoud(`The price of ${combo.name} is ${combo.price} dollars.`);
      handled = true;
    }

    if (normalizedCommand.includes('calories') && comboNameOrId) {
      // this.readOutLoud(`${combo.name} has ${combo.calories} calories.`);
      handled = true;
    }

    if (normalizedCommand.includes('options') && comboNameOrId) {
      let options = `For ${combo.name}, you can choose drinks sizes: ${combo.options.drinks.join(', ')}.`;
      if (combo.options.fries) {
        options += ` Fries sizes: ${combo.options.fries.join(', ')}.`;
      }
      if (combo.options.pieces) {
        options += ` McNugget pieces: ${combo.options.pieces.join(', ')}.`;
      }
      this.readOutLoud(options);
      handled = true;
    }
  });

  if (normalizedCommand.includes('grand total')) {
    const total = this.grandTotal(); // Assuming grandTotal method calculates subtotal + tax
    this.readOutLoud(`The total order amount is $${total.toFixed(2)}.`);
    handled = true;
  }

  if (!handled) {
    if (normalizedCommand.includes('checkout')) {
      this.readOutLoud('Checkout activated. Proceeding to finalize your order.');
      this.checkoutDialog = true;
    } else if (normalizedCommand.includes('add another')) {
      this.welcomeAndStartRecording('Ready for the next order.');
    } else {
      this.readOutLoud("I'm sorry, I didn't understand that. Could you please repeat or ask about something else?");
    }
  }
},


  addToCart(combo) {
    const comboToAdd = {
      ...combo,
      selectedOptions: this.selectedOptions[combo.id] || {}
    };
    this.cart.push(comboToAdd);
    // this.readOutLoud(`Added ${combo.name} to cart. Would you like to add another item or proceed to checkout?`);
    this.cartDialog = true;

    // Play a success sound indicating the item was added
    new Audio(successAudio).play();

  
    this.$nextTick(() => {
      this.scrollToElement('cart');
    });

    // Automatically close the cart dialog after 8 seconds
    setTimeout(() => {
      this.cartDialog = false;
    }, 8000);
    setTimeout(() => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
}, 10000);

    // Restart recording to listen for further commands from the user after 12 seconds
    setTimeout(() => {
      this.startRecording();
    }, 12000);

    // Stop the recording after a total of 24 seconds to limit user response time
    setTimeout(() => {
      this.stopRecording();
    }, 24000);
  },
  removeFromCart(item) {
    const index = this.cart.findIndex(cartItem => cartItem.id === item.id);
    if (index !== -1) {
      this.cart.splice(index, 1);
    }
  },
  //   readOutLoud(msg) {
  //     const speech = new SpeechSynthesisUtterance(msg);
  //     const voices = window.speechSynthesis.getVoices();
  //     speech.voice = voices.find(voice => voice.name === 'Google UK English Male') || voices[0];
  //     speech.pitch = 1;
  //     speech.rate = 1;
  //     speech.volume = 1;
  //     window.speechSynthesis.speak(speech);
  //   }
  // },
},

showOverlay(message) {
  this.overlayMessage = message;
  this.overlayVisible = true;
},

hideOverlay() {
  this.overlayVisible = false;
},

askForFurtherAction() {
  this.readOutLoud("Do you have any other questions or need information on another combo?");
  setTimeout(() => {
    this.startRecording();
  }, 3000);
},

    submitOrder() {
      if (this.$refs.form.validate()) {
        axios.post('/api/orders', {
          customer: this.customer,
          cart: this.cart
        }).then(() => {
          this.readOutLoud('Thank you for your order!');
          this.cart = [];
          this.customer = {};
          this.checkoutDialog = false;
        }).catch(error => {
          console.error('Order submission failed:', error);
          this.readOutLoud('Failed to submit order, please try again.');
        });
      }
    },
  computed: {
    subtotal() {
    return this.cart.reduce((acc, item) => acc + item.price, 0);
  },
  taxAmount() {
    return this.subtotal * this.taxRate;
  },
  grandTotal() {
    return this.subtotal + this.taxAmount;
  },
    totalPrices() {
      return this.combos.map(combo => {
        const selected = this.selectedOptions[combo.id];
        let price = combo.basePrice || combo.price;
        if (selected && selected.drinks) {
          price += this.basePrices.drinks[selected.drinks];
        }
        if (selected && selected.pieces) {
          price = this.basePrices.pieces[selected.pieces];
        }
        if (selected && selected.fries) {
          price += this.basePrices.fries[selected.fries];
        }
        return {
          ...combo,
          price: price.toFixed(2)
        };
      });
    }
  }
};
</script>


<style scoped>
:root {
  --background-color: rgba(10, 25, 47, 0.308);
  --accent-color: rgba(30, 136, 229, 0.8);
  --text-color: #ffffff;
  --button-color: rgba(30, 136, 229, 1);
  --button-hover-color: rgba(30, 136, 229, 0.9);
}
body, html {
  font-family: 'Roboto', sans-serif;
  color: var(--text-color);
  background-color: #121212;
}
.v-application {
  font-size: 1.2rem;
}
.info-dialog {
  position: absolute;
  margin-top: 100px;
  margin-right: 0px;
  top: -70px;
  left: 70%;
  width: 500px; /* Adjust size as needed */
  color: white; /* White text color */
  font-size: 1.5rem; /* Larger font size */
  font-weight: bold; /* Bold font for better readability */
  font-family: Lato, sans-serif;
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.8); /* Semi-opaque white background */
}

.info-dialog .v-card-title, .info-dialog .v-card-text {
  color: white; /* White text color */
  font-size: 1.5rem; /* Larger font size */
  font-weight: bold; /* Bold font for better readability */
}

/* Add some padding to the dialog content for aesthetics */
.info-dialog .v-card-text {
  padding: 20px;
}

/* Optional: Add a subtle shadow for better visibility on varying backgrounds */
.info-dialog .v-dialog {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}
.custom-text {
  font-size: 24px;
  line-height: 1.5;
  padding-block: 10px;
  margin-block: 10px;
  height: auto;
}
.dots-container {
  display: flex;
  justify-content: center;
  align-items: flex-end; /* Align dots at the bottom */
  height: 50px; /* Adjust based on your layout */
}

.dots {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin: 0 5px; /* Space between dots */
  background-color: black; /* Initial color */
  animation: dotFlashing 1.5s infinite; /* Total animation time adjusted */
}

.dots:nth-child(1) {
  animation-delay: 0s; /* Start immediately */
  background-color: red; /* First dot color */
}

.dots:nth-child(2) {
  animation-delay: 0.5s; /* Delay by 0.5s */
  background-color: green; /* Second dot color */
}

.dots:nth-child(3) {
  animation-delay: 1s; /* Delay by 1s */
  background-color: blue; /* Third dot color */
}

@keyframes dotFlashing {
  0%, 100% { opacity: 1; }
  50% { opacity: 0; }
}

.cart-summary p {
  margin: 0.5rem 0;
  font-size: 1rem;
  color: var(--text-color);
}

.v-list-item-subtitle {
  font-weight: bold;
}

.v-icon {
  cursor: pointer;
}
.menutext {
  text-align: center;
  font-family: 'Roboto', sans-serif;
  color: #ffffff;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3; /* Adjust based on average words per line */
  font-size: 1rem; /* Smaller font size */
  padding-block: 20px;
  padding-inline: 40px;
  border-radius: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5), inset 0 0 10px rgba(0, 0, 0, 0.1), 0 0px 0 #000;
  margin-block: 10px;
}

.menutext:hover {
  background: #121212;
  overflow: visible;
  -webkit-line-clamp: initial;
  font-size: 1.2rem; /* Larger font size on hover */
  background-size: auto;
  padding-block: 20px;
  padding-inline: 40px;
  border-radius: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5), inset 0 0 10px rgba(0, 0, 0, 0.1), 0 0px 0 #000;
  margin-block: 10px;
}


.v-btn {
  background-color: var(--button-color);
  color: var(--text-color);
  border: none;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  font-size: 1.1rem;
  padding: 0.75rem 1.5rem;
}
.v-btn:hover {
  background-color: var(--button-hover-color);
}
.v-card, .v-dialog, .v-select {
  background-color: var(--background-color);
  border-radius: 12px;
  color: var(--text-color);
  box-shadow: 0 8px 16px rgba(0,0,0,0.2);
}
.v-card-title, .v-card-text, .v-card-actions {
  padding: 1rem;
}
.v-img {
  opacity: 0.9;
  transition: opacity 0.3s ease;
}
.v-img:hover {
  opacity: 1;
}
.v-form {
  background: linear-gradient(145deg, rgba(255,255,255,0.1), rgba(0,0,0,0.1));
  padding: 2rem;
  border-radius: 12px;
}
.v-text-field__slot {
  font-size: 1.2rem;
}
.v-select__slot {
  font-size: 1.2rem;
}
.v-dialog--active {
  border: 1px solid var(--accent-color);
  box-shadow: 0 0 20px var(--accent-color);
}
@media (max-width: 600px) {
  .v-application {
    font-size: 1rem;
  }
  .v-btn {
    font-size: 1rem;
    padding: 0.5rem 1rem;
  }
  .v-card, .v-dialog {
    padding: 0.5rem;
  }
  .v-card-title, .v-card-text, .v-card-actions, .v-form {
    padding: 0.5rem;
  }
  .cart-summary p {
    font-size: 0.85rem;
  }
  .menutext {
    font-size: 0.7rem; /* Even smaller font size for very small devices */
    padding: 10px; /* Add some padding to ensure text doesn't touch the edges */
    transition: font-size 0.3s ease-in-out; /* Ensure transition applies here too */
  }

  .menutext:hover {
    font-size: 0.85rem; /* Slightly larger on hover, but not as big as on larger screens */
  }
}
</style>